import React from 'react';
import _ from 'lodash';

import {
  useSaveRepairCodesMutation,
  useRepairCodesWidgetQuery
} from 'generated/graphql';

import * as types from './types';



export interface IData {
  formState: types.IFormState;
}

export function useQuery(storeId: string) {
  const tuple = useRepairCodesWidgetQuery({
    variables: {
      storeId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        formState: {
          repairCodes: _.map(tuple.data?.store?.repairCodes ?? [], (repairCode): types.IRepairCode => ({
            id: repairCode.id,
            repairCode: repairCode.repairCode
          }))
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}



export function useSaveRepairCodes(storeId: string) {
  const [fnMutate, tuple] = useSaveRepairCodesMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = React.useCallback(
    async (formState: types.IFormState) => {
      await fnMutate({
        variables: {
          input: {
            storeId,
            repairCode: _.map(formState.repairCodes, repairCode => repairCode.repairCode)
          }
        }
      });
    },
    [
      storeId,
      fnMutate
    ]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
